import { h, Component } from 'preact';
import cx from 'classnames';

import style from './style.less';

import { trackingProvider, trackProps, DIMENSION } from '@cube/track';
import { Icon } from '@cube/blocks';

/** A generic title for cards
 *  @param {String}  title		the title to display
 *  @param {Object}  link			the link url and label to display if applicable
 */
@trackingProvider({
	[DIMENSION.componentpath]: 'CardHeader'
})
export default class CardHeader extends Component {

	render({ title, titleIcon, description, link, action, customization, qeId, theme, headerClass }) {
		if (!title) return;

		return (
			<div class={cx(style.header, style[theme], style[headerClass])} qid={qeId + '-header'}>
				<div class={style.top}>
					<div class={style.title} qid={qeId + '-title'}>
						{ titleIcon &&
							<Icon name={titleIcon} />
						}
						{title}
					</div>
					{ link && link.url && link.label &&
						<a
							{...trackProps({
								[DIMENSION.text]: link.label
							}, this.context)}
							class={style.link}
							href={link.url}
							qid={qeId + '-link'}
							target={link.open_new_window ? '_blank' : '_self'}
							rel="noopener noreferrer"
						>
							{link.label}
							<Icon name="go-cube" />
						</a>
					}
					{ action && action.onClick && action.label &&
						<div
							class={style.link}
							onClick={action.onClick}
						>
							{action.label}
						</div>
					}
					{ customization }
				</div>
				{ description &&
					<div class={style.description} qid={qeId + '-description'}>
						{description}
					</div>
				}
			</div>
		);
	}
}
